export default "__VITE_ASSET__0facc04d__"